import Box from '@mui/material/Box';
import ButtonBase from '@mui/material/ButtonBase';
import Typography from '@mui/material/Typography';
import type React from 'react';
import { NAVY, RADIUS_CARD, RADIUS_COIN, SHADOW, SHADOW_CARD, SURFACE_CONTAINER_LOWEST } from 'styles/tokens';

interface Props {
  greeting: string;
  suggestions: string[];
  onSelect: (question: string) => void;
  disabled?: boolean;
}

const ChatIntro: React.FC<Props> = ({ greeting, suggestions, onSelect, disabled = false }) => (
  <Box
    sx={{
      flex: 1,
      minHeight: 0,
      overflow: 'auto',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'flex-start',
      gap: 1.25,
      px: 2,
      py: 2,
      scrollbarWidth: 'none',
      '&::-webkit-scrollbar': { display: 'none' },
      '@keyframes widgetIntroIn': {
        from: { opacity: 0, transform: 'translateY(8px)' },
        to: { opacity: 1, transform: 'translateY(0)' },
      },
    }}
  >
    <Box
      sx={{
        maxWidth: '90%',
        px: 2,
        py: 1.5,
        borderRadius: RADIUS_CARD,
        backgroundColor: SURFACE_CONTAINER_LOWEST,
        boxShadow: SHADOW_CARD,
        animation: 'widgetIntroIn 0.4s cubic-bezier(0.25, 0.8, 0.25, 1) both',
      }}
    >
      <Typography sx={{ color: NAVY, fontSize: '0.95rem', lineHeight: 1.5, whiteSpace: 'pre-line' }}>
        {greeting}
      </Typography>
    </Box>

    {suggestions.map((question, index) => (
      <ButtonBase
        key={question}
        onClick={() => onSelect(question)}
        disabled={disabled}
        sx={{
          maxWidth: '92%',
          alignSelf: 'flex-end',
          px: 2,
          py: 1.15,
          textAlign: 'right',
          justifyContent: 'flex-end',
          borderRadius: RADIUS_COIN,
          backgroundColor: SURFACE_CONTAINER_LOWEST,
          boxShadow: SHADOW_CARD,
          color: NAVY,
          fontSize: '0.875rem',
          lineHeight: 1.4,
          fontWeight: 500,
          transition: 'transform 0.15s ease, box-shadow 0.2s ease',
          animation: 'widgetIntroIn 0.4s cubic-bezier(0.25, 0.8, 0.25, 1) both',
          animationDelay: `${0.08 * (index + 1) + 0.1}s`,
          '&:hover': { transform: 'translateY(-1px)', boxShadow: SHADOW },
          '&.Mui-disabled': { opacity: 0.6 },
        }}
      >
        {question}
      </ButtonBase>
    ))}
  </Box>
);

export default ChatIntro;
